/**
 * Geschenkverpackung (gift wrap) add-on.
 *
 * Adds an optional "Als Geschenk verpacken lassen" checkbox to every
 * product's add-to-cart form (rendered in snippets/buy-buttons.liquid).
 * When checked at the moment "In den Warenkorb" is clicked, the gift-wrap
 * product is added to the cart together with the main product, using the
 * same quantity, and then the page is reloaded so the cart icon / drawer
 * reflect the correct, final cart state.
 */
(function () {
  if (window.__giftWrapInit) return;
  window.__giftWrapInit = true;

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

      var checkbox = form.querySelector('.gift-wrap-checkbox');
      if (!checkbox || !checkbox.checked) return;

      var variantId = checkbox.getAttribute('data-gift-wrap-variant-id');
      var mainVariantField = form.elements['id'];
      if (!variantId || !mainVariantField || !mainVariantField.value) return;

      // Intercept before the theme's own <product-form> submit handler runs,
      // so the main item isn't added twice.
      event.preventDefault();
      event.stopImmediatePropagation();

      var quantityField = form.elements['quantity'];
      var quantity = quantityField ? parseInt(quantityField.value, 10) || 1 : 1;

      var submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.setAttribute('disabled', 'disabled');

      var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            { id: parseInt(mainVariantField.value, 10), quantity: quantity },
            { id: parseInt(variantId, 10), quantity: quantity },
          ],
        }),
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error((err && err.description) || 'Cart add failed');
            });
          }
          return response.json();
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function (err) {
          console.error('Geschenkverpackung: Fehler beim Hinzufügen zum Warenkorb:', err);
          if (submitButton) submitButton.removeAttribute('disabled');
          window.alert(
            'Es gab ein Problem beim Hinzufügen zum Warenkorb. Bitte versuche es noch einmal.'
          );
        });
    },
    true
  );
})();
